import styled from 'styled-components';
import { rgba } from 'polished';
import Accordion from '@material-ui/core/Accordion';

// CONSTANTS
import { PORCELAIN, ATHENS_GRAY } from '@/constants/colors';

export const AccordionStyled = styled(Accordion)`
  padding: 16px 16px 16px 0;
  border-radius: 12px;

  &:not(:first-of-type):after {
    content: '';
    position: absolute;
    top: -1px;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: ${ATHENS_GRAY};
  }

  &.Mui-expanded {
    margin: 0;

    &:before {
      opacity: 1;
    }
  }

  &:not(.Mui-expanded) {
    &:before {
      content: '';
      display: block !important;
      height: 100%;
      width: calc(100% + 32px);
      margin-left: -16px;
      border-radius: 12px;
      background-color: transparent;
      transition: background-color 0.4s;
    }

    &:hover {
      &:before {
        background-color: ${PORCELAIN};
      }
    }
  }

  .accordion {
    &__summary {
      padding: 0;

      .MuiAccordionSummary-content {
        margin: 0;
        align-items: center;
      }
    }

    &__icon {
      height: 48px;
      width: 48px;
      background-color: ${p => rgba(p.color, 0.25)};
      border-radius: 12px;
      margin-right: 16px;
      display: flex;
      align-items: center;
      justify-content: center;

      i {
        font-size: 2rem;
        color: ${p => p.color};
      }
    }
  }
`;

export default AccordionStyled;
